export default {"src":"/_next/static/media/ape.c8bfbafd.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};